import styled, { css } from "styled-components";
import { responsive } from "../../theme/reponsive";

export const DashboardStyleWrapper = styled.div<{ toggle: boolean }>`
   display: grid;
   grid-template-columns: ${({ toggle }) => (toggle ? "60px" : "240px")} 1fr;
   grid-template-areas:
      "navbar navbar"
      "sidebar  main-content"
      "sidebar  main-content";
   @media screen and (max-width: 768px) {
      grid-template-columns: 20px 1fr;
   }
`;

export const MainContent = styled.div<{ toggle: boolean; isNew?: boolean }>`
   background-color: ${({ theme, isNew }) => (isNew ? "#f4f4f4" : theme.colors?.grey01)};
   grid-area: main-content;
   width: 100%;
   overflow-x: auto;
   margin: 0 auto;
   ${({ toggle }) =>
      toggle &&
      css`
         width: 100%;
         @media screen and (min-width: 1450px) {
            width: 130rem;
         }
      `}
   @media screen and (max-width: 768px) {
      padding: 5px;
   }
`;

export const StudyMainContent = styled.div<{ toggle: boolean; isNew?: boolean }>`
   background: #e5e5e5;
   grid-area: main-content;
   width: 100%;
   overflow-x: auto;
   margin: 0 auto;
   height: 95vh;
   ${({ toggle }) =>
      toggle &&
      css`
         width: 100%;
         @media screen and (min-width: 1450px) {
            width: 130rem;
         }
      `}
   @media screen and (max-width: 768px) {
      padding: 5px;
   }
`;

export const MainContentContainer = styled.div`
   grid-area: main-content;
   margin: 30px;
   @media screen and (max-width: 768px) {
      padding: 5px;
   }
`;

export const StudyAbroadMainContentContainer = styled.div`
   grid-area: main-content;
   padding: 30px;
   background: #e5e5e5;
   width: 100%;
   height: 90vh;
   .profile-heading {
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      margin-bottom: 23px;
   }
   .settings-heading {
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      margin-bottom: 23px;
   }
   @media screen and (max-width: 768px) {
      padding: 5px;
   }
`;

export const DashboardGridWrapper = styled.div`
   display: grid;
   grid-template-columns: 3fr 1fr;
   column-gap: 30px;
`;

export const DashboardRightContent = styled.div``;
export const DashboardLeftContent = styled.div`
   width: 100%;
`;

export const DashboardUserBlock = styled.div`
   position: relative;
   background: #cee0fe;
   margin-bottom: 20px;
   border-radius: 6px;
   padding: 20px;
   display: flex;
   justify-content: space-between;
   ${responsive("$xsmall")`
   display: grid;
   grid-template-columns: repeat(1, 1fr);
`}
   .admin-info {
      p {
      }
      h4 {
         font-size: 2.5rem;
         font-weight: 500;
         margin: 10px 0;
      }
      h6 {
         font-size: 1.5rem;
         color: #666666;
         font-weight: 400;
         margin: 0;
      }
   }
   .img-holder {
      width: 350px;
      position: absolute;
      top: -45px;
      right: 20px;
      img {
         max-width: 100%;
         height: 100%;
         object-fit: contain;
      }
   }
`;

export const ApplicationStatus = styled.div`
   font-weight: 400;
   font-size: 16px;
   line-height: 20px;
   color: "grey";
   .viewed {
      color: #3578e5;
   }
   .successful {
      color: #29b67a;
   }
   .failed {
      color: #e91c24;
   }
`;

export const ApplicationCard = styled.div`
   background: #ffffff;
   border-radius: 5px;
   width: 80%;
   padding: 70px;
   margin-bottom: 11px;
   .header-one {
      font-weight: 700;
      font-size: 22px;
      line-height: 28px;
      color: #444444;
      text-align: center;
   }
   .border {
      border-bottom: 1px solid #cccccc;
      margin-top: 29px;
      margin-left: -70px;
      margin-right: -70px;
   }
   .header {
      font-weight: 500;
      font-size: 22px;
      line-height: 28px;
      color: #444444;
      margin-bottom: 38px;
      padding-top: 30px;
   }
   .flex-details {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 22px;
   }
   .detail {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #444444;
   }
   .value {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #666666;
      text-transform: capitalize;
   }
`;

export const DashboardTop = styled.div`
   width: 100%;
   display: flex;
   justify-content: space-between;
   margin-bottom: 50px;

   .text-content {
      width: 50%;
      h4 {
         font-weight: 500;
         font-size: 24px;
         line-height: 30px;
         color: #444444;
      }
      p {
         font-weight: 400;
         font-size: 16px;
         line-height: 20px;
         color: #444444;
      }
      h5 {
         font-weight: 500;
         font-size: 18px;
         line-height: 23px;
         color: #3578e5;
         margin-top: 10px;
      }
   }
   .filter {
      width: 20%;
   }
`;

export const CardArea = styled.div`
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 24px;
`;

export const Card = styled.div<{ color?: string; left?: string; w?: string; mb?: string }>`
   background: #ffffff;
   border-radius: 10px;
   width: ${({ w }) => (w ? w : "30%")};
   height: 175px;
   padding: 25px;
   display: flex;
   color: #444444;
   margin-bottom: ${({ mb }) => mb && mb};
   .circle {
      width: 65px;
      height: 65px;
      background-color: ${({ color }) => color && color};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
   }
   .stats {
      margin-top: 0px;
      margin-left: 14px;
      p {
         font-weight: 400;
         font-size: 12px;
         line-height: 18px;
      }
      h4 {
         font-weight: 700;
         font-size: 45px;
         line-height: 57px;
         margin-top: 10px;
      }
      .view {
         display: flex;
         align-items: center;
         color: #3578e5;
         font-weight: 400;
         font-size: 16px;
         line-height: 20px;
         text-decoration-line: underline;
         margin-top: 8px;
         cursor: pointer;
         p {
            margin-right: 6px;
         }
      }
   }
   .rate {
      color: #29b67a;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-left: ${({ left }) => left && left};
   }
   .declined_rate {
      color: red;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-left: ${({ left }) => left && left};
   }
`;

export const BlueCard = styled.div<{ url?: string }>`
   width: 30%;
   height: auto;
   background-image: url(${({ url }) => url && url});
   border-radius: 10px;
   background-position: center;
   background-size: cover;
   padding: 26px;
   .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      button {
         border: none;
         color: #3578e5;
      }
      h4 {
         font-weight: 700;
         font-size: 20px;
         line-height: 25px;
         color: #ffffff;
      }
   }
   .details {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #ffffff;
      margin-top: 10px;
      p {
         margin-bottom: 8px;
      }
   }
`;

export const BlackCard = styled.div<{ url?: string }>`
   width: 30%;
   height: 175px;
   background-image: url(${({ url }) => url && url});
   border-radius: 10px;
   background-position: center;
   background-size: cover;
   padding: 26px;
   .details {
      font-weight: 700;
      font-size: 18px;
      line-height: 23px;
      color: #ffffff;
   }
   button {
      border: none;
      width: 125px;
      margin-top: 30px;
   }
`;

export const ChartArea = styled.div`
   background-color: #fff;
   width: 100%;
   height: 447px;
   padding: 36px;
   border-radius: 10px;
   .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h4 {
         font-weight: 400;
         font-size: 18px;
         line-height: 23px;
         color: #000000;
      }
      .school {
         display: flex;
         align-items: center;
         .label {
            width: 10.48px;
            height: 9.17px;
            background: #e54d3a;
            border-radius: 2px;
            margin-right: 5px;
         }
         p {
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            color: #606060;
         }
      }
   }
   .chart-section {
      width: 100%;
      min-height: 250px;
      margin-top: 94px;
   }
`;

export const DashboardTabs = styled.div`
   border-bottom: 1px solid #cccccc;
   .content-tabs {
      display: flex;
      align: center;
      color: #000000;
      .tab {
         font-weight: 400;
         font-size: 18px;
         line-height: 23px;
         color: #999999;
         padding-bottom: 10px;
         border: none;
         outline: none;
         background-color: transparent;
         text-align: start;
         border-bottom: 3px solid transparent;
         cursor: pointer;
      }
      .active {
         color: ${({ theme }) => theme.colors?.primary};
         font-weight: 500;
         border-bottom: 3px solid #3578e5;
      }
   }
`;

export const DashboardCard = styled.div<{ color?: string; left?: string; w?: string }>`
   background: #ffffff;
   border-radius: 10px;
   width: ${({ w }) => (w ? w : "48%")};
   height: 175px;
   padding: 25px;
   display: flex;
   color: #444444;
   margin-bottom: 24px;
   .circle {
      width: 65px;
      height: 65px;
      background-color: ${({ color }) => color && color};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
   }
   .stats {
      margin-top: 0px;
      margin-left: 14px;
      p {
         font-weight: 400;
         font-size: 12px;
         line-height: 18px;
      }
      h4 {
         font-weight: 700;
         font-size: 45px;
         line-height: 57px;
         margin-top: 10px;
      }
      .view {
         display: flex;
         align-items: center;
         color: #3578e5;
         font-weight: 400;
         font-size: 16px;
         line-height: 20px;
         text-decoration-line: underline;
         margin-top: 8px;
         p {
            margin-right: 6px;
         }
      }
   }
   .rate {
      color: #29b67a;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-left: ${({ left }) => left && left};
   }
`;

export const DashboardMain = styled.div`
   margin-top: 38px;
   width: 100%;
   display: flex;
   justify-content: space-between;
   .default-content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
   }
   .left-side {
      width: 67%;
      .content {
         width: 100%;
         display: flex;
         flex-wrap: wrap;
         justify-content: space-between;
      }
   }
   .right-side {
      width: 30%;
      .content {
         width: 100%;
      }
   }
`;

export const LikesCard = styled.div`
   width: 100%;
   background-color: #fff;
   padding: 30px;
   font-weight: 400;
   font-size: 16px;
   line-height: 20px;
   color: #444444;
   margin-bottom: 24px;
   max-height: 60rem;
   overflow-y: scroll;
   h5 {
      margin-bottom: 16px;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #444444;
   }
   .border-class {
      border-bottom: 1px solid #cccccc;
      margin-bottom: 29px;
   }
   .flex-content {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      align-items: center;
      width: 100%;
      .sc-name {
         width: 50%;
      }
      .like-number {
         display: flex;
         align-items: center;
         gap: 5px;
      }
   }

   .see-all {
      margin-top: 46px;
      color: #3578e5;
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      padding-bottom: 5px;
      cursor: pointer;
   }
   .rate {
      color: #29b67a;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
   }
   .declined_rate {
      color: red;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
   }
`;

export const SchoolCount = styled.div`
   width: 100%;
   background-color: #fff;
   padding: 30px;
   font-weight: 400;
   font-size: 16px;
   line-height: 20px;
   color: #444444;
   max-height: 79rem;
   overflow-y: scroll;
   h5 {
      margin-bottom: 16px;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #444444;
   }
   .border-class {
      border-bottom: 1px solid #cccccc;
      margin-bottom: 29px;
   }
   .stats {
      display: flex;
      h3 {
         font-weight: 700;
         font-size: 45px;
         line-height: 57px;
         color: #444444;
         margin-top: 14px;
      }
      .schools {
         display: flex;
         align-items: flex-end;
         padding-bottom: 8px;
         margin-left: 5px;
         p {
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #666666;
            align-items: flex-end;
         }
      }
   }

   .view {
      display: flex;
      align-items: center;
      color: #3578e5;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      text-decoration-line: underline;
      margin-top: 23px;
      p {
         margin-right: 6px;
      }
   }
`;

export const DoughnutWrapper = styled.div`
   padding: 30px;
   width: 100%;
   height: 475px;
   background: #fff;
   border-radius: 10px;
   margin-bottom: 24px;
   h6 {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #444444;
      margin-top: 20px;
      margin-left: 30px;
      margin-bottom: 40px;
   }
   .flex-area {
      width: 100%;
      height: 300px;
      display: flex;
      justify-content: space-between;
      .chart-area {
         width: 60%;
      }
      .text-area {
         width: 35%;
         margin-top: 50px;
      }
   }
`;

export const ChartLegend = styled.div<{ bg?: string }>`
   width: 100%;
   display: flex;
   align-items: center;
   margin-bottom: 23px;
   .label {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 20px;
      background: ${({ bg }) => bg && bg};
   }
   .text {
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      color: #444444;
   }
`;

export const MapWrapper = styled.div`
   padding: 30px;
   width: 100%;
   height: 590px;
   background: #fff;
   border-radius: 10px;
   margin-bottom: 24px;
`;

export const FilterWrapper = styled.div`
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   width: 60%;
   column-gap: 15px;
   margin-top: 20px;
   .date-filter {
      width: 120px !important ;
      border: 1px solid grey;
      border-radius: 4px;
   }
   button {
      margin: 0 auto;

      @media screen and (max-width: 468px) {
         width: -webkit-fill-available;
      }
   }

   @media screen and (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      row-gap: 15px;
      flex-direction: column;
   }
`;

export const DurationFilterWrapper = styled.div`
   display: grid;
   grid-template-columns: repeat(1, 1fr);
   width: 25%;
   column-gap: 15px;
   margin-top: 20px;
   button {
      margin: 0 auto;

      @media screen and (max-width: 468px) {
         width: -webkit-fill-available;
      }
   }

   @media screen and (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      row-gap: 15px;
      flex-direction: column;
   }
`;

export const FlexActionArea = styled.div`
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: flex-end;
   gap: 10px;
   .country-filter {
      width: 188px;
   }
`;
